import React, { useState } from "react";
import { setBooking, setStep } from "../../../Reducer/bookingSlice";
import { useDispatch, useSelector } from "react-redux";
import NextPrev from "../../../Helpers/Components/NextPrev";
import Select from 'react-select'
import Handler from "../../../Helpers/Components/Handler"
import { toast } from "react-toastify";

const Trip = (props) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const booking = useSelector(state => state?.booking?.booking)
    const setSteps = () => {
        dispatch(setStep(1))
    }
    const handleNext = async () => {
        if (!booking?.package) {
            toast.error("Package is required")
        } else if (!booking?.km?.start) {
            toast.error("Start KM is required");
        } else if (Number(booking?.km?.start) <= 0) {
            toast.error("Start KM is invalid");
        } else if ((Number(booking?.fuel?.start || 0) < 0) || (Number(booking?.fuel?.start || 0) > 100)) {
            toast.error("Start Fuel is invalid");
        } else {
            setLoading(true);
            let data = {
                package: booking?.package || 300,
                km: { start: Number(booking?.km?.start || 0), ...(booking?.km?.end ? { end: Number(booking?.km?.end || 0) } : {}) },
                fuel: { start: Number(booking?.fuel?.start || 0), ...(booking?.fuel?.end ? { end: Number(booking?.fuel?.end || 0) } : {}) },
                fastTag: { start: Number(booking?.fastTag?.start || 0), ...(booking?.fastTag?.end ? { end: Number(booking?.fastTag?.end || 0) } : {}) }
            }
            const response = await Handler({ method: 'patch', url: `/booking/delivery/third/update/${props?.bookingId}`, data })
            setLoading(false)
            if (response?.success) {
                dispatch(setStep(3))
            } else {
                toast.error(response?.message)
            }
        }
    }
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="package" className="form-label"> Package </label>
                        <Select
                            value={booking?.package ? { label: booking?.package, value: booking?.package } : ""}
                            onChange={(e) => { dispatch(setBooking({ package: e.value })) }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled={loading}
                            options={[
                                { label: "300", value: "300" },
                                { label: "400", value: "400" },
                                { label: "500", value: "500" }
                            ]} className="mb-3" />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="segment" className="form-label"> Type of Car </label>
                        <input name="segment" id="segment" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.car?.segment || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="startKm" className="form-label"> Start KM </label>
                        <input name="startKm" id="startKm" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { dispatch(setBooking({ km: { ...(booking?.km?.end ? { end: booking?.km?.end } : {}), start: e.target.value } })) } }} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.km?.start || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="startFuel" className="form-label"> Start Fuel </label>
                        <input name="startFuel" id="startFuel" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { dispatch(setBooking({ fuel: { ...(booking?.fuel?.end ? { end: booking?.fuel?.end } : {}), start: e.target.value } })) } }} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.fuel?.start ?? 0} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="startFastTag" className="form-label"> Start FasTag </label>
                        <input name="startFastTag" id="startFastTag" onChange={(e) => { if (/^-?\d{0,}$/.test(e.target.value)) { dispatch(setBooking({ fastTag: { ...(booking?.fastTag?.end ? { end: booking?.fastTag?.end } : {}), start: e.target.value } })) } }} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.fastTag?.start ?? 0} />
                    </div>
                </div>
            </div>
            <NextPrev step={2} setStep={setSteps} last={3} onClick={handleNext} loading={loading} />
        </React.Fragment>
    )
}

export default Trip;